"use client";
import Header from "./Header";
import { usePathname } from "next/navigation";
export default function LayoutWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  return (
    <>
      {!pathname.includes("details") && <Header />}
      {children}
    </>
  );
}
